import barba from "@barba/core";
import {isDebug, isDesktop, isIe11, scrollSetting} from "./globalVars";
import Page from "./page";
import transition from "./transition";
import PageIndex from "../pages/page-index";
import PageGuide from "../pages/page-guide";
import PageMypagePoint from "../pages/page-mypage-point";
import PageMypageLogin from "../pages/page-mypage-login";
import PageMypageMembership from "../pages/page-mypage-membership";
import PageMypageReward from "../pages/page-mypage-reward";
import PageCalibrationRitual from "../pages/page-calibration-ritual";
import PagePrestige from "../pages/page-prestige";

import PageProductList from "../pages/page-product-list";
import PageProductDetail from "../pages/page-product-detail";
import Header from "./header";
import PageTechnology from "../pages/page-technology";
import PageOeraStory from "../pages/page-oera-story";
import PageShop from "../pages/page-shop";
import PageMypageModify from "../pages/page-mypage-modify";
import {isTagging} from "../../../setting/site-data";
import PageNewsList from "../pages/page-news-list";
import PageNewsView from "../pages/page-news-view";
import PageMagazineList from "../pages/page-magazine-list";


const siteData = require('/setting/site-data');

let instance;

export default class Address {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;
    }

    init(scrollControl) {
        this.scrollControl = scrollControl;
        this.loadingEl = document.querySelector('.loading-din-holder')
        this.setDefaultPage();

        if (isIe11()) {
            console.log('ie - 11')
        }

        //ie 11 일 경우 barba를 설정하지 않음
        if (isIe11() || !isDesktop()) {
            this.isBarba = false;
            return;
        }

        this.setBarba();
    }

    setDefaultPage() {
        this.currentNameSpace = this.getCurrentNameSpace();
        this.currentPage = this.getPageByNamespace(this.currentNameSpace);
        this.currentPage.init();

        this.currentPage.load().then( ()=> {
            new Header().setSubNavigation(this.currentNameSpace, this.getCurrentClassList());
            this.currentPage.setEl(document.querySelector('.app'));
        });
    }

    getCurrentNameSpace() {
        let el = document.getElementsByClassName('app')[0];
        return el.getAttribute('data-page-namespace');
    }
    getCurrentClassList() {
        let el = document.getElementsByClassName('app')[0];
        return el.classList;
    }

    setShowLoading() {
        new Header().onDesktopProductMenuHideHandler();
        this.loadingEl.style.display = 'block';
    }

    setHideLoading() {
        new Header().setScrollDefault();
        this.loadingEl.style.display = 'none';
    }

    setBarba() {
        this.isBarba = true;
        barba._this = this;
        barba.init({
            transitions: [transition],
            schema: {
                prefix: 'data-page'
            }
        });

        // barba life cycle
        //                          (destroy)                     (init, load)             (show)
        // before > beforeLeave > Leave > afterLeave > beforeEnter > Enter > afterEnter > after
        barba.hooks.beforeLeave(() => {
            this.setShowLoading();
        });

        barba.hooks.leave((data)=>{
            //페이지 이동시 스크롤을 0으로 만듬
            this.currentPage.setDestroy();
            new Header().setHideTabletMenu();
        });

        barba.hooks.beforeEnter((data)=>{
            window.scrollTo(0, 0);
            new Header().setSubNavigation(data.next.namespace, data.next.container.classList);
        });

        barba.hooks.enter( (data)=>{
            this.currentNameSpace = data.next.namespace;
            this.currentPage = this.getPageByNamespace(data.next.namespace);
            this.currentPage.init();
            return this.currentPage.load();
        });

        barba.hooks.afterEnter( (data)=> {
            // console.log('- 4 > data loaded = ' + this.currentPage.isLoaded);
        });

        barba.hooks.after((data)=> {
            // console.log('--------> 4 before');
            console.log(data.next.container);
            if (isTagging) {
                gtag('set', 'page_path', window.location.pathname);
                gtag('event', 'page_view');
            }
            this.currentPage.setEl(data.next.container);
        });
    }

    setScroll(container){
        if (isDebug) console.log('- 6 > scroll re init');
        this.scrollControl.setContainer(container);
    }

    getPageByNamespace(namespace) {

        let ext = '.json';
        if (siteData.isOeraExtension) {
            ext = '.oera';
        }


        switch(namespace) {
            case 'guide-aside':
                return new PageGuide( namespace, siteData.url_data + 'data_guide' + ext );

            case 'index':
                return new PageIndex( namespace,siteData.url_data + 'data_index' + ext);

            case 'prestige':
                return new PagePrestige( namespace,siteData.url_data + 'data_index' + ext);
            case 'product-list' :
                return new PageProductList( namespace, siteData.url_data + 'data_product_list' + ext);

            case 'product-detail' :
                return new PageProductDetail( namespace, siteData.url_data + 'data_product_detail' + ext);
            case 'prestige-detail' :
                return new PageProductDetail( namespace, siteData.url_data + 'data_product_detail' + ext);


            case 'oera-story' :
                return new PageOeraStory(namespace, siteData.url_data + 'data_oera_story' + ext);
            case 'technology':
                return new PageTechnology(namespace, siteData.url_data + 'data_technology' + ext);
            case 'calibration-ritual':
                return new PageCalibrationRitual( namespace, siteData.url_data + 'data_index' + ext);

            // case 'mypage-point':
            //     return new PageMypagePoint(namespace,siteData.url_data + 'data_mypage_point' + ext);
            // case 'mypage-login':
            //     return new PageMypageLogin(namespace, siteData.url_data + 'data_mypage_login' + ext);
            // case 'mypage-membership':
            //     return new PageMypageMembership(namespace, siteData.url_data + 'data_mypage_membership' + ext);
            // case 'mypage-modify':
            //     return new PageMypageModify(namespace, siteData.url_data + 'data_mypage_modify' + ext);
            // case 'mypage-reward':
            //     return new PageMypageReward(namespace, siteData.url_data + 'data_mypage_reward' + ext);
            case 'shop' :
                return new PageShop(namespace, siteData.url_data + 'data_shop' + ext);

            case 'magazine-list' :
                return new PageMagazineList(namespace, siteData.url_data + 'data_magazine_list' + ext);

            case 'news-list' :
                return new PageNewsList(namespace, siteData.url_data + 'data_news_list' + ext);
            case 'news-view' :
                return new PageNewsView(namespace, siteData.url_data + 'data_news_view' + ext);

            default:
                return new Page(namespace, siteData.url_data + 'data_error' + ext);
        }
    }
}
